import { createWorkspace, fetchWorkspaces, fetchWorkspaceByRole, loginWorkspace, deleteWorkspace, fetchFilteredUsers, updateWorkspace } from '../api/api';

export const addWorkspace = (workspace, navigate, callback) => async (dispatch) => {
    try {
        const res = await createWorkspace(workspace);
        if (res.data.status === 'success') {
            dispatch({ type: 'CREATE_WORKSPACE', payload: res.data });
            localStorage.setItem('workspaceID', res.data.workspaceId);
            callback?.(true);
            return true;

        } else if (res.data.status === "fail") {
            dispatch({ type: 'CREATE_WORKSPACE_FAIL', payload: res.data.message });
            callback?.(false);
            return false;
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: 'LOGIN_WORKSPACE_FAIL', payload: error.message })
    }
}


export const getWorkspaces = () => async (dispatch) => {
    try {
        const res = await fetchWorkspaces();
        dispatch({ type: 'GET_WORKSPACES', payload: res.data });

    } catch (err) {
        console.log(err);
    }
}

export const getSpecificWorkspace = (id) => async (dispatch) => {
    try {
        const res = await loginWorkspace(id);
        dispatch({ type: 'GET_SPECIFICWORKSPACE', payload: res.data });

    } catch (error) {
        console.log(error);
    }
}

export const getWorkspaceByRole = (role) => async (dispatch) => {
    try {
        const res = await fetchWorkspaceByRole(role);
        dispatch({ type: 'GET_WORKSPACEBYROLE', payload: res.data })
    } catch (error) {
        console.log(error);
    }
}


export const openWorkspace = (id, navigate) => async (dispatch) => {
    try {
        dispatch({ type: 'LOGIN_WORKSPACE_REQUEST' });

        const res = await loginWorkspace(id);
        if (res.status === 200) {
            localStorage.setItem('workspaceID', res.data.data._id);

            dispatch({ type: 'LOGIN_WORKSPACE_SUCCESS', payload: res.data.data._id })

            navigate(`/${id}/content-models`);
        } else {
            dispatch({ type: 'LOGIN_WORKSPACE_FAIL', payload: 'workspace login fail' });
        }


    } catch (err) {
        console.log(err);
    }
}

export const setWorkspaceID = (workspaceID) => ({
    type: 'SET_WORKSPACE_ID',
    payload: workspaceID,
});

export const removeWorkspace = (id, navigate) => async (dispatch) => {
    try {
        const res = await deleteWorkspace(id);
        dispatch({ type: 'DELETE_WORKSPACE', payload: res.data })

        navigate(`/space`)
    } catch (error) {
        console.log(error)
    }
}

export const getFilteredUsers = (filter) => async (dispatch) => {
    try {
        const res = await fetchFilteredUsers(filter);
        dispatch({ type: 'GET_FILTEREDUSERS', payload: res.data })
    } catch (error) {
        console.log(error);
    }
}

export const putWorkspace = (workspaceId, data, type) => async (dispatch) => {
    try {
        let res;

        switch (type) {
            case 'updateName':
                res = await updateWorkspace(workspaceId, {
                    name: data
                });
                break;

            case 'addUsers':
                res = await updateWorkspace(workspaceId, {
                    newUsers: data
                });
                break;

            case 'updateRole':
                res = await updateWorkspace(workspaceId, {
                    updateRole: data
                });
                break;

            case 'removeUsers':
                res = await updateWorkspace(workspaceId, {
                    removeUsers: data
                });
                break;

            case 'newApiKeys':
                res = await updateWorkspace(workspaceId, {
                    newApiKeys: data
                });
                break;

            case 'removeApiKeys':
                res = await updateWorkspace(workspaceId, {
                    removeApiKeys: data
                });
                break;

            case 'newWriteApiKeys':
                res = await updateWorkspace(workspaceId, {
                    newWriteApiKeys: data
                });
                break;

            case 'removeWriteApiKeys':
                res = await updateWorkspace(workspaceId, {
                    removeWriteApiKeys: data
                });
                break;

            case 'newLocales':
                res = await updateWorkspace(workspaceId, {
                    newLocales: data
                });
                break;

            case 'removeLocales':
                res = await updateWorkspace(workspaceId, {
                    removeLocales: data
                });
                break;
            case 'newAiModels':
                res = await updateWorkspace(workspaceId, {
                    newAiModels: data
                });
                break;
            case 'removeAiModels':
                res = await updateWorkspace(workspaceId, {
                    removeAiModels: data
                });
                break;
            case 'defaultAiModel':
                res = await updateWorkspace(workspaceId, {
                    defaultAiModel: data
                });
                break;
            case 'invalidateCdnCache':
                res = await updateWorkspace(workspaceId, {
                    invalidateCdnCache: data
                });
                break;

            default:
                console.log('Invalid update type');
                break;
        }

        if (res?.data) {
            dispatch({
                type: 'UPDATE_CURRENT_WORKSPACE',
                payload: res.data
            });
        }

    } catch (error) {
        console.log(error);
    }
};
